export default __webpack_public_path__ + "static/media/penalized.77c6074a.svg";